var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-3 px-3 py-3"},[_c('h5',{staticStyle:{"color":"#000"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('apexchart',{attrs:{"type":"bar","options":_vm.chartOptions,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }